<template>
  <BasePageContainer class="page goal goal-edit pt-5 pb-10">
    <div class="page__head edit-head fixed-top p-3">
      <h1 class="edit-head__heading">
        <img
          src="@/assets/images/icon_flag-w.svg"
          class="img-fluid edit-head__icon mr-2">
        目標
      </h1>
    </div>
    <div class="page__form general-form pt-4 p-md-6">
      <validation-observer v-slot="observer">
        <form v-if="localGoal">
          <div class="general-form__group form-group mt-4">
            <label
              class="col-form-label">目標名</label>
            <validation-provider 
              v-slot="v"
              name="目標名"
              rules="required|max:40">
              <input
                v-model="localGoal.name"
                type="text"
                class="form-control">
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <template v-if="isRepeat">
              <label class="col-form-label">開始月</label>
              <b-row
                align-v="center"
                class="mx-0 px-0 col col-6">
                <year-month-select
                  v-model="selectedYearMonth"
                  :disabled="true" />
              </b-row>
            </template>
            <template v-else>
              <label class="col-form-label">期間</label>
              <b-row
                align-v="center"
                align-h="center"
                class="mx-0 px-0 col">
                <b-col
                  class="px-0"
                  cols="12"
                  sm="4"
                  md="5">
                  <validation-provider
                    v-if="isMd"
                    v-slot="v"
                    name="開始日"
                    rules="required|before_date:@終了日|valid_date">
                    <b-form-datepicker
                      v-model="localGoal.startDate"
                      hide-header
                      placeholder="日付を選択してください">
                      <template v-slot:button-content>
                        <div
                          class="material-icons mr-2 d-flex align-items-center">
                          event_available
                        </div>
                      </template>
                    </b-form-datepicker>
                  </validation-provider>
                  <validation-provider
                    v-else
                    name="開始日"
                    rules="required|before_date:@終了日|valid_date">
                    <b-form-input
                      v-model="localGoal.startDate"
                      placeholder="日付を選択してください"
                      size="sm"
                      type="date" />
                  </validation-provider>
                </b-col>
                <div
                  class="d-flex align-items-center mx-2">
                  〜
                </div>
                <b-col
                  cols="12"
                  sm="4"
                  md="5"
                  class="px-0">
                  <validation-provider
                    v-if="isMd"
                    v-slot="v"
                    name="終了日"
                    rules="required|after_date:@開始日|valid_date">
                    <b-form-datepicker
                      v-model="localGoal.endDate"
                      hide-header
                      placeholder="日付を選択してください">
                      <template v-slot:button-content>
                        <div
                          class="material-icons mr-2 d-flex align-items-center">
                          event_available
                        </div>
                      </template>
                    </b-form-datepicker>
                  </validation-provider>
                  <validation-provider
                    v-else
                    name="終了日"
                    rules="required|after_date:@開始日|valid_date">
                    <b-form-input
                      v-model="localGoal.endDate"
                      placeholder="日付を選択してください"
                      size="sm"
                      type="date" />
                  </validation-provider>
                </b-col>
              </b-row>
            </template>
            <p
              class="text-primary d-flex justify-content-center">
              {{ dateErrorMessage(observer['errors']['開始日']) }}
            </p>
            <p
              class="text-primary d-flex justify-content-center">
              {{ dateErrorMessage(observer['errors']['終了日']) }}
            </p>
            <p class="text-primary px-2 d-flex justify-content-center">
              {{ nonFieldError }}
            </p>
          </div>
          <div
            v-if="hasRepeatGroup"
            class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label">毎月繰り返す</label>
            <div>
              <div
                class="repeat-btn"
                @click="onClickRepeat">
                <img
                  v-if="isRepeat"
                  class="repeat-btn__icon"
                  src="@/assets/images/icon_repeat_active.svg">
                <img
                  v-else
                  class="repeat-btn__icon"
                  src="@/assets/images/icon_repeat.svg">
              </div>
            </div>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <div class="row">
              <div class="col-6">
                <label
                  class="col-form-label">目標数</label>
                <validation-provider
                  v-slot="v"
                  name="目標数"
                  rules="required|hankaku_number">
                  <input
                    v-model="localGoal.goalNumber"
                    type="number"
                    min="0"
                    class="form-control">
                  <p
                    class="text-primary">
                    {{ v.errors[0] }}
                  </p>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label">上部に固定</label>
            <div>
              <div
                class="goal-pin-btn"
                @click="onClickPin">
                <img
                  v-if="localGoal.pin"
                  class="goal-pin-btn__icon"
                  src="@/assets/images/icon_pin.svg">
                <img
                  v-else
                  class="goal-pin-btn__icon"
                  src="@/assets/images/icon_pin-g.svg">
              </div>
            </div>
          </div>
          <div
            v-if="lockGoalOption"
            class="general-form__group form-group mt-3 mt-md-4">
            <label
              class="col-form-label">限定公開</label>
            <div>
              <div
                class="goal-lock-btn"
                @click="onClickLockBtn">
                <span
                  class="material-icons goal-lock-btn__icon"
                  :class="{'goal-lock-btn__icon--locked': localGoal.isLocked}">
                  lock
                </span>
              </div>
            </div>
          </div>
          <div class="general-form__btn row mt-6">
            <div class="col-6">
              <button
                type="button"
                class="btn btn-block btn-cancel"
                @click="onClickCancel">
                キャンセル
              </button>
            </div>
            <div class="col-6">
              <button
                :disabled="observer.invalid"
                type="button"
                class="btn btn-block btn-primary"
                @click="observer.passes(onClickSave)">
                保存
              </button>
            </div>
          </div>
          <div class="general-form__item d-flex form-info justify-content-between mt-6">
            <div
              style="cursor: pointer;"
              class="form-info__delete"
              @click="onClickDelete">
              <span class="form-info__icon material-icons">
                delete
              </span>
              削除する
            </div>
            <div class="form-info__detail text-right">
              <div class="form-info__name">
                <p><b class="mr-2">作成者</b>{{ localGoal.createdBy.name }}</p>
              </div>
              <div class="form-info__date">
                <p>最終更新日時: {{ localGoal.updatedAt | prettyDateTime }}</p>
              </div>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
  </BasePageContainer>
</template>

<script>
import YearMonthSelect from '@/components/parts/YearMonthSelect.vue'
import startOfMonth from 'date-fns/startOfMonth'
import endOfMonth from 'date-fns/endOfMonth'
import format from 'date-fns/format'
export default {
  components: {
    YearMonthSelect
  },
  data() {
    return {
      localGoal: null,
      goal: null,
      nonFieldError: '',
      isMd: false,
      lockGoalOption: false,
      isRepeat: false,
      selectedYearMonth: null,
    }
  },
  computed: {
    memberId() {
      return this.$route.params.id
    },
    goalId() {
      return this.$route.params.goalId
    },
    hasRepeatGroup() {
      return this.goal.repeatGroup != null
    },
    willChangeRepeat() {
      return this.isRepeat !== this.hasRepeatGroup
    },
    willRepeatOff() {
      return this.willChangeRepeat && !this.isRepeat
    },
    isChangedRange() {
      return this.localGoal.startDate !== this.goal.startDate 
        || this.localGoal.endDate !== this.goal.endDate
    },
    patchBody() {
      return {
        name: this.localGoal.name,
        start_date: this.isChangedRange ? this.localGoal.startDate : undefined,
        end_date: this.isChangedRange ? this.localGoal.endDate : undefined,
        goal_number: this.localGoal.goalNumber,
        pin: this.localGoal.pin,
        is_locked: this.localGoal.isLocked
      }
    }
  },
  watch: {
    isRepeat(val) {
      if (val) {
        const date = this.localGoal.startDate
        this.setGoalRange(date)
      }
    },
    selectedYearMonth(date) {
      if (this.isRepeat){
        this.setGoalRange(date)
      }
      
    }
  },
  async created() {
    this.isMd = window.matchMedia('(min-width: 768px)').matches
    this.$store.commit('startLoading')
    await this.fetchAll().catch((err) => {
      console.error('err', err)
      this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
    })
    this.setRepeatYearMonth()
    this.$store.commit('finishLoading')
  },
  methods: {
    setRepeatYearMonth() {
      const startDate = new Date(this.localGoal.startDate)
      this.selectedYearMonth = format(startDate, 'yyyy-MM')
    },
    setGoalRange(date) {
      const baseDate = new Date(date)
      const startDate = startOfMonth(baseDate)
      const endDate = endOfMonth(baseDate)
      this.localGoal = {...this.localGoal, startDate: format(startDate, 'yyyy-MM-dd'), endDate: format(endDate, 'yyyy-MM-dd')}
    },
    async fetchGoal() {
      this.goal = await this.$axios.get(`/goals/${this.goalId}/`).then(res => res.data)
      this.isRepeat = this.goal.repeatGroup != null
      this.localGoal = Object.assign({}, this.goal)
    },
    async fetchLockGoalOption() {
      this.lockGoalOption = await this.$axios.get('/tenants/').then((res) => res.data.lockGoalOption)
    },
    fetchAll() {
      return Promise.all([this.fetchGoal(), this.fetchLockGoalOption()])
    },
    async onClickSave() {
      this.$store.commit('startLoading')
      let isFailed = false

      if (this.willRepeatOff) {
        await this.$axios.post(`/goals/${this.goalId}/repeat_off/`).catch(() => {
          isFailed = true
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      }

      await this.$axios.patch(`/goals/${this.goalId}/`, this.patchBody)
        .catch((err) => {
          isFailed = true
          if (!err.response) {
            this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
            return
          }
          if (err.response.data.startDate || err.response.data.endDate) {
            this.nonFieldError = '実際に存在する日付を入力してください'
            return
          }
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })

      if (!isFailed) {
        this.$router.push(`/members/${this.memberId}?goalId=${this.goalId}`)
        this.$store.commit('notify/set', {message: '目標の編集が完了しました。'})
      }
      this.$store.commit('finishLoading')
    },
    async onClickDelete() {
      this.$store.commit('startLoading')
      let isFailed = false
      if (!window.confirm('目標を削除してもよろしいですか?')) return

      if (this.hasRepeatGroup) {
        await this.$axios.post(`/goals/${this.goalId}/repeat_off/`).catch(() => {
          isFailed = true
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      }

      // リピートをoffにできていない場合は削除処理をさせない
      if (isFailed) return

      await this.$axios.delete(`/goals/${this.goalId}/`).catch(() => {
        isFailed = true
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      if (!isFailed) {
        this.$router.replace(`/members/${this.memberId}`)
        this.$store.commit('notify/set', {message: '目標を削除しました。'})
      }
      this.$store.commit('finishLoading')
    },
    onClickCancel() {
      this.$router.push(`/members/${this.memberId}`)
    },
    dateErrorMessage(v) {
      if (!v) return ''
      return v[0]
    },
    onClickPin() {
      this.localGoal.pin = !this.localGoal.pin
    },
    onClickLockBtn() {
      if (this.localGoal.isLocked && window.confirm('すべてのメンバーに公開しますか？')) {
        this.localGoal.isLocked = false
        return
      }
      if (window.confirm('自分と指導者だけに限定して公開しますか？')) {
        this.localGoal.isLocked = true
      } 
    },
    onClickRepeat() {
      this.isRepeat = !this.isRepeat
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-head{
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    width: calc(100% - 422px);
    right: 0;
    left: auto;
  }
  &__icon{
    height: 22px;
    width: auto;
  }
  &__heading{
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}

.goal-pin-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background-color: $white;
  padding: 3px;
  text-align: center;
  &__icon {
    width: 20px;
    height: auto;
  }
}

.goal-lock-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  padding: 3px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &__icon {
    color: $grey11;
    &--locked {
      color: $black;
    }
  }
}

.repeat-btn {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background-color: $white;
  padding: 3px;
  text-align: center;
  &__icon {
    cursor: pointer;
    width: 20px;
    height: auto;
  }
}

.form-info{
  color: $grey09;
  &__delete{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
  }
  &__icon{
    display: inline-block;
    vertical-align: top;
  }
  &__date{
    font-size: $fs-m;
  }
}
</style>